import React from "react";
import { Container, Row, Col } from "reactstrap";
import AboutImage from "../../../assets/images/about/img-01.jpg";

const About = () => {
  return (
    <React.Fragment>
      <section className="section section-lg overflow-hidden pt-lg-5 pb-lg-5">
        <Container>
          <Row className="align-items-center g-0 gy-4">
            <Col lg={6} className="pe-lg-4 pe-xl-5">
              <div className="section-title me-lg-4">
                <h6 className="sub-title mb-3">¿QUIÉNES SOMOS?</h6>
                <h2 className="title mb-4 mb-md-5">
                  Conectamos empresas con Talento
                </h2>
                <p className="text-muted mb-4">
                  En AVANZA EMPLEO somos una empresa especializada en la conexión estratégica entre el talento humano y las organizaciones. Acompañamos a personas y empresas en la construcción de relaciones laborales sólidas, alineadas con los objetivos profesionales y empresariales de cada parte.
                </p>
                <p className="text-muted mb-4">
                  Trabajamos con un enfoque integral que combina reclutamiento, selección y gestión del talento, apoyados en procesos claros, tecnología y criterios de evaluación que nos permiten identificar perfiles idóneos para cargos operativos, profesionales, estratégicos y directivos.
                </p>
                <p className="text-muted mb-4">
                  Creemos en el talento como motor de crecimiento. Por eso, impulsamos oportunidades laborales que generan valor, promueven el desarrollo profesional y fortalecen a las organizaciones en su camino hacia la excelencia.
                </p>
                <p className="text-muted mb-0">
                  En AVANZA EMPLEO, avanzamos contigo para construir el futuro laboral que buscas.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="about-img mt-4 mt-lg-0 ms-lg-2">
                <img src={AboutImage} alt="" className="img-fluid rounded shadow-sm" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default About;
